export default __webpack_public_path__ + "static/media/d.8e304064.svg";